.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  padding: 1.15rem 2.5rem;
  gap: 2rem;
  transition: background 0.4s, backdrop-filter 0.4s, border-color 0.4s;
  border-bottom: 1px solid transparent;
}

.nav.scrolled {
  background: rgba(8, 13, 20, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-color: var(--teal-border);
}

.logo {
  font-family: var(--font-display);
  font-size: 1.45rem;
  font-weight: 900;
  color: var(--white);
  text-decoration: none;
  letter-spacing: 0.02em;
  margin-right: auto;
  flex-shrink: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.dot {
  color: var(--teal);
  font-size: 1.3rem;
  line-height: 1;
}

.links {
  display: flex;
  list-style: none;
  gap: 2rem;
  align-items: center;
}

.link {
  font-family: var(--font-body);
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mist);
  text-decoration: none;
  transition: color 0.2s;
}

.link:hover {
  color: var(--teal);
}

.cta {
  font-family: var(--font-body);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-decoration: none;
  background: var(--teal);
  color: var(--ink);
  padding: 0.55rem 1.2rem;
  border-radius: 5px;
  transition: background 0.2s, transform 0.15s;
  flex-shrink: 0;
}

.cta:hover {
  background: #7ee8d8;
  transform: translateY(-1px);
}

/* Burger */
.burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: auto;
}

.bar {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--mist);
  border-radius: 2px;
  transition: transform 0.25s, opacity 0.25s;
}

.barOpen1 { transform: translateY(7px) rotate(45deg); }
.barOpen2 { opacity: 0; }
.barOpen3 { transform: translateY(-7px) rotate(-45deg); }

/* Drawer */
.drawer {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  background: rgba(8, 13, 20, 0.97);
  border-bottom: 1px solid var(--teal-border);
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2rem;
  gap: 0.25rem;
  z-index: 199;
  animation: fadeIn 0.2s ease;
}

.drawerLink {
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 500;
  color: var(--mist);
  text-decoration: none;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--border);
  transition: color 0.2s;
}

.drawerLink:hover {
  color: var(--teal);
}

.drawerCta {
  display: inline-block;
  margin-top: 1rem;
  background: var(--teal);
  color: var(--ink);
  text-decoration: none;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 0.75rem 1.5rem;
  border-radius: 5px;
  text-align: center;
}

@media (max-width: 768px) {
  .nav { padding: 1rem 1.4rem; }
  .links { display: none; }
  .cta { display: none; }
  .burger { display: flex; }
}
